// extracted by mini-css-extract-plugin
module.exports = {"modal":"nD","container":"nE","actions":"nF","button":"nG","text":"nH"};